export class Address {
    private _id: number | null = null;
    private _city: string = '';
    private _house: string = '';
    private _street: string = '';
    private _country: string = '';
    private _name: string = '';
    private _x: number | null = null;
    private _y: number | null = null;

    public getCoordsAsText() {
        if (this._x === null || this._y === null) {
            return '';
        }
        return `${this._x.toFixed(6)}, ${this._y.toFixed(6)}`;
    }
    public setCoords(x: number | null, y: number | null): void {
        this._x = x;
        this._y = y;
    }

    public get id(): number | null {
        return this._id;
    }

    public get name(): string {
        return this._name;
    }

    public set name(name: string) {
        this._name = name;
    }

    public get city(): string {
        return this._city;
    }

    public get house(): string {
        return this._house;
    }

    public get street(): string {
        return this._street;
    }

    public get country(): string {
        return this._country;
    }

    public get x(): number | null {
        return this._x;
    }

    public get y(): number | null {
        return this._y;
    }

    public getFullAddress(): string {
        return `${this._city}, ${this._street} ${this._house}`;
    }

    public set city(city: string) {
        this._city = city;
    }

    public set house(house: string) {
        this._house = house;
    }

    public set street(street: string) {
        this._street = street;
    }
}
